import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/painel/simulador-sisu")({
	beforeLoad: () => {
		throw redirect({ to: "/simulador-sisu", replace: true });
	},
});
